import React from 'react';
import ServicesLayout from '../../../components/ServicesLayout/ServicesLayout';
import ServiceCreator from './ServicesCreator';
import { isAdminUser, isDistrictAdminUser } from '../../../lib/utils';

const title = 'Kreator eusługi';


export default {

  path: '/service_creator',
  children: [
    {
      path: '/',
      async action(ctx) {
        const state = await ctx.store.getState();
        const isAdmin = await isAdminUser(ctx);
        let isDistrictAdmin = null;
        if (!isAdmin) {
          isDistrictAdmin = await isDistrictAdminUser(ctx);
          if (!isDistrictAdmin) {
            return { redirect: '/' };
          }
        }
        return {
          title,
          chunk: 'ServiceCreator',
          component: <ServicesLayout isAdmin><ServiceCreator title={title} isDistrictAdmin={isDistrictAdmin} user={state.user} /></ServicesLayout>,
        };
      },
    },
  ],
};



// WEBPACK FOOTER //
// src/routes/admin/service_creator/index.js